/*

? First, let's import the interface that will describe the shape of our object.

*/

import StateInterface from "../state-interface";
import { faq } from "./faq";

/*

& Now let's describe an initial state for the object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

const single_faq_page_data: StateInterface["single_faq_page"] = {
  faq: faq,
};

export const single_faq_page = single_faq_page_data;

export default single_faq_page_data;
